/**
 * <Register 
 *    posterDetail={}
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './Register.scss';
import moment from 'moment';

class Register extends React.Component {
  static propTypes = {
    posterDetail: PropTypes.object.isRequired,
  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.renderTicket = this.renderTicket.bind(this);

  }

  componentWillMount() {

  }


  renderTicket(item, index) {
    const {
      title,
      ordered_amount,
      amount,
      end_at,
    } = item;

    const indexStr = (index + 1) > 9 ? index : '0' + (index + 1);

    const endDateStr = end_at ? <span className='date'>{moment(end_at).locale('en').format('MMM DD YYYY, ddd')}</span> : __('None', 'poster.register');

    return (
      <div className='ticket-item' key={index}>
        <div className='col-sm-1 index'>
          <h4>{indexStr}</h4>
        </div>
        <div className='col-sm-4'>
          <h3>{item.title || "  "}</h3>
        </div>
        <div className='col-sm-4'>
          <h4>{__('Deadline', 'poster.register')}: {endDateStr}</h4>
        </div>
        <div className='col-sm-3'>
          <h4>{__('Registered', 'poster.register')}: {ordered_amount || 0} / {amount || ""}{amount === 0 && __('No Limit', 'poster.register')}</h4>
        </div>
      </div>
    );
  }
  
  render() {
    const {
      ticket = [],
    } = this.props.posterDetail;
    
    const {
      onClickRegister,
    } = this.props;

    return (
      <div className='poster-register-list'>
        <section className='header'>
          <h1>{ticket.length > 0 ? __('Items', 'poster.register') : __('Item', 'poster.register')}</h1> 
          { ticket.length > 0 && <a className='btn btn-primary register-now' onClick={onClickRegister}>{__('Register Now', 'poster.register')}</a> }
        </section>
        <section className='ticket-item-list'>
          { ticket.length > 0 &&
            ticket.map((item, key)=>this.renderTicket(item, key))
          }
        </section>
        <section className='footer'>
          <h3>
            {__('Note: Currently we only accept online registration and offline payment.', 'poster.register')}
          </h3>
        </section>
      </div>
    )
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/shared/PosterView/Register.js